import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../App";

const GlobalCounter  = () => {

    const {globalCounter, setGlobalCounter} = useContext(AppContext)


    return (
                <div className="container bg-dark p-2 mt-2 px-4">
                    <h3>Global Counter</h3>
                    <p>Click: {globalCounter}</p>
                </div>

    )
}

export default GlobalCounter